import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { deletePlaceById, getPlacesByWorkspaceId } from '../thunks/places';

const placesAdapter = createEntityAdapter({});

export const placesSlice = createSlice({
  name: 'places',
  initialState: placesAdapter.getInitialState({}),
  reducers: {
    addPlace: (state, action) => {
      placesAdapter.addOne(state, action.payload);
    },
    updatePlace: (state, action) => {
      placesAdapter.updateOne(state, {
        id: action.payload.id,
        changes: action.payload,
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlacesByWorkspaceId.fulfilled, (state, action) => {
        placesAdapter.upsertMany(state, action.payload);
      })
      .addCase(deletePlaceById.fulfilled, (state, action) => {
        placesAdapter.removeOne(state, action.payload.id);
      });
  },
});

export const placesAdapterSelectors = placesAdapter.getSelectors(
  (state) => state.places
);

export const { addPlace, updatePlace } = placesSlice.actions;

export default placesSlice.reducer;
